export class AddressModel {
    constructor() {
        this.addressLine1 = null;
        this.addressLine2 = null;
        this.city = null;
        this.state = null;
        this.stateId = null;
        this.zip = null;
        this.country = null;
        this.countryId = null;
    }
}
export default class Address extends AddressModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
